export const navLinks=[
    { id: 1, title: 'Home', url: '/' },
    { id: 2, title: 'Recipes', url: '/recipes' },
    { id: 3, title: 'Favourites', url: '/favourites' },
]